import React from "react";
import { Box, Button, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import type { Icon } from "@tabler/icons-react";
import { IconArrowRight, IconRoute } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import styles from "./PageMoved.module.css";

export interface PageMovedProps {
  /** Defaults to "This page has moved". */
  title?: string;
  /** Where the feature lives now, in a sentence or two. */
  message: React.ReactNode;
  /** Icon for the tile; defaults to a route icon. */
  icon?: Icon;
  /** Defaults to the Calendar. */
  actionLabel?: string;
  actionPath?: string;
}

/**
 * Stands in for a page that was removed or folded into another surface, so
 * bookmarks and old links land on an explanation instead of a 404, with one
 * button to carry on.
 */
export default function PageMoved({
  title = "This page has moved",
  message,
  icon: TileIcon = IconRoute,
  actionLabel = "Go to Calendar",
  actionPath = "/admin/calendar",
}: PageMovedProps) {
  const navigate = useNavigate();
  return (
    <Box className={styles.shell}>
      <Stack className={styles.card} align="center" gap="sm">
        <ThemeIcon variant="light" color="teal" size={48} radius={12}>
          <TileIcon size={24} />
        </ThemeIcon>
        <Title order={1} className={styles.title}>
          {title}
        </Title>
        <Text className={styles.message}>{message}</Text>
        <Button
          color="teal"
          mt="xs"
          rightSection={<IconArrowRight size={16} />}
          onClick={() => navigate(actionPath)}
        >
          {actionLabel}
        </Button>
      </Stack>
    </Box>
  );
}
